<template>
  <application-layout>
    <v-main>
      <v-container>
        <h1>Manage Robots.txt</h1>
        <p>Use the box below to manage the content of the robots.txt file for the site.</p>

        <v-form @submit.prevent="submitRobotsForm">
            <v-textarea
              data-testid="robots-text-textarea"
              class="robots-text-textarea"
              filled
              label="robots.txt"
              v-model.trim="robots"
              :disabled="loading"
              clearable
            />

            <v-btn
              data-testid="robots-save-btn"
              class="robots-save-btn ml-0"
              color="primary"
              :loading="loading"
              :disabled="loading"
              type="submit"
            >
              Save
            </v-btn>
        </v-form>
      </v-container>
    </v-main>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";

export default {
  data() {
    return {
      robots: null,
      loading: false
    };
  },

  components: {
    ApplicationLayout
  },

  methods: {
    submitRobotsForm() {
      const payload = {
        ident: "global_robots",
        value: this.robots
      };

      this.$store.dispatch("updateGlobalSetting", payload);
    }
  },

  created() {
    this.loading = true;
    this.$store.dispatch("getGlobalSetting", "global_robots")
      .then(resp => {
        this.robots = resp.data.setting.value;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }
};
</script>
